import { useParams } from "react-router-dom";
import Button from "components/Buttons/Button/Button";
import MainCard from "components/layout/MainCard/MainCard";
import Sitemap from "routes/sitemap";
import StaticPage from "../../components/StaticPage/StaticPage";
import scss from "./CheckoutSuccess.module.scss";
import { useTranslation } from "react-i18next";

const CheckoutSuccess = () => {
    const { t } = useTranslation();

    const { orderId } = useParams();
    return (
        <MainCard>
            <div className="page-container">
                <div className={`p page-content ${scss.container}`}>
                    <section className={scss.confirmation} aria-labelledby="order-success-title">
                        <header className={scss.header}>
                            <span className={scss.successIcon}>
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                    <circle cx="12" cy="12" r="9" />
                                    <path d="m8 12 2.5 2.5L16 9" />
                                </svg>
                            </span>
                            <h2 id="order-success-title">{t("cart_success-default-title")}</h2>
                        </header>
                        <div className={scss.content}>
                            <p>{t("cart_success-default-introduction")},</p>
                            <p>{t("cart_success-default-p1")}</p>
                            <div className={scss.orderNumber}>
                                <span>{t("cart_success-default-p2")}</span>
                                <strong>#{orderId}</strong>
                            </div>
                            <StaticPage slug={"cart_success-default-page"} />
                            <Button to={Sitemap.home} label={t("cart_checkout-default-button-continue", "Nastavi kupovinu")} className={scss.continue} />
                        </div>
                    </section>
                </div>
            </div>
        </MainCard>
    );
};

export default CheckoutSuccess;
